import { ProfileForm } from '@profile/store/ProfileForm';

export const profileForm = new ProfileForm();
